import { AdminRouter } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

AdminRouter.addRoutes([
  {
    path: '/',
    name: 'dashboard',
    component: () => import('./Dashboard.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/charts/earning',
    component: () => import('./Earning.vue'),
    meta: {
      auth: true,
    },
  },
])

messageGroups.push('graphs')
